import axios from 'axios';

const api = axios.create({
  baseURL: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' 
    ? `http://${window.location.hostname}:8000/api` 
    : '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to ALL requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token refresh on 401 errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired, redirect to login
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const plaidAPI = {
  createLinkToken: async () => {
    const response = await api.post('/plaid/create-link-token/');
    return response.data;
  },

  exchangePublicToken: async (publicToken, metadata) => {
    const response = await api.post('/plaid/exchange-token/', {
      public_token: publicToken,
      metadata: metadata,
    });
    return response.data;
  },

  syncTransactions: async () => {
    const response = await api.post('/plaid/sync-transactions/');
    return response.data;
  },

  listPlaidAccounts: async () => {
    const response = await api.get('/plaid/accounts/');
    return response.data;
  },

  listORMAccounts: async () => {
    const response = await api.get('/plaid/orm-accounts/');
    return response.data;
  },

  linkAccount: async (plaidAccountId, ormId, ormType) => {
    const response = await api.post('/plaid/link-account/', {
      plaid_account_id: plaidAccountId,
      orm_id: ormId,
      orm_type: ormType,
    });
    return response.data;
  },

  migrateTransactions: async () => {
    const response = await api.post('/plaid/migrate-transactions/');
    return response.data;
  },
};

export default api;